const getShortenedListItemsLabel = ({
  items,
  emptyText = '',
  showCount = 2
}: {
  items: any[];
  emptyText?: string;
  showCount?: number;
}) => {
  if (!items?.length) return emptyText;
  const visible = items.slice(0, showCount).join(', ');
  const remainingCount = items.length - showCount;
  return remainingCount > 0 ? `${visible}, +${remainingCount}` : visible;
};

const getDropdownOptionsList = (options: string[]) => {
  return options.map((option) => ({
    label: option,
    value: option
  }));
};

// Inline "merged with" label for contexts where the hover merge icon can't work —
// map marker tooltips and Gantt popups serialized to static markup.
const getMergedCustomerLabel = (
  displayCustomerName?: string,
  originalCustomerName?: string
): string | undefined =>
  originalCustomerName && originalCustomerName !== displayCustomerName
    ? `${displayCustomerName} (Merged with - ${originalCustomerName})`
    : displayCustomerName;

export { getShortenedListItemsLabel, getDropdownOptionsList, getMergedCustomerLabel };
